import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import {
  DEFAULT_BASE_URL,
  FR_HEADER,
  TO_HEADER,
} from "src/const/const-from-env";
import i18n from "src/lang/i18n";
import { goBack } from "src/utils";
import PopupService from "src/utils/PopupService";
class Services {
  axios: AxiosInstance;
  constructor() {
    this.axios = axios.create({
      baseURL: DEFAULT_BASE_URL,
      timeout: 90000,
    });

    this.axios = axios;
    this.axios.defaults.withCredentials = false;

    // //! Interceptor request
    axios.interceptors.request.use(
      function (request) {
        return {
          ...request,
          headers: {
            ...request.headers,
          },
        };
      },
      function (response) {
        return response;
      }
    );
    // ! Interceptor response
    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        const config = error?.config;
        const isNoInternet = error
          ?.toString()
          ?.startsWith("Error: Network Error");
        const status = error?.response?.status;
        const isTimeoutOrServerError =
          error?.code == "ECONNABORTED" || status >= 500;
        if (isNoInternet) {
          PopupService.instance.current.open({
            visible: true,
            content: i18n.t("no_internet"),
            onOk: () => {
              PopupService.instance.current.close();
              goBack();
            },
          });
        } 
        // else if (isTimeoutOrServerError) {
        //   PopupService.instance.current.open({
        //     visible: true,
        //     content: i18n.t("general_error"),
        //     onOk: () => {
        //       PopupService.instance.current.close();
        //       goBack();
        //     },
        //   });
        // }
        return Promise.reject(error);
      }
    );
  }
  //!

  get<T = any, R = T>(url: string, config?: AxiosRequestConfig): Promise<R> {
    return this.axios.get<T, R>(url, { ...config });
  }

  post<T = any, R = T>(
    url: string,
    data?: T,
    config?: AxiosRequestConfig
  ): Promise<R> {
    return this.axios.post<T, R>(url, data, { ...config });
  }

  delete<T = any, R = T>(url: string, config?: AxiosRequestConfig): Promise<R> {
    return this.axios.delete<T, R>(url, { ...config });
  }

  put<T = any, R = T>(
    url: string,
    data: any,
    config?: AxiosRequestConfig
  ): Promise<R> {
    return this.axios.put<T, R>(url, data, { ...config });
  }
  patch<T = any, R = T>(
    url: string,
    data: any,
    config?: AxiosRequestConfig
  ): Promise<R> {
    return this.axios.patch<T, R>(url, data, { ...config });
  }
}

export default new Services();
